import { apiGet, apiPut } from '../../../adapters/api-client/api';

/** MC-06 §6 — the family's private rating for one enrollment and cycle. */
export interface SatisfactionSurveyView {
  enrollmentId: string;
  cycleId: string;
  status: 'NOT_AVAILABLE' | 'OPEN' | 'CLOSED';
  question: {
    id: string;
    version: string;
    text: string;
    scale: ReadonlyArray<{ value: number; label: string }>;
  };
  closesAt?: string;
  answer?: { score: number; respondedAt: string };
}

const path = (enrollmentId: string) =>
  `/api/v1/enrollments/${encodeURIComponent(enrollmentId)}/satisfaction-survey`;

export const getSatisfactionSurvey = (enrollmentId: string) =>
  apiGet<SatisfactionSurveyView>(path(enrollmentId));

/** The enrollment id is repeated as the explicit confirmation of which child it is for (MC06-AC22). */
export const answerSatisfactionSurvey = (enrollmentId: string, score: number) =>
  apiPut<SatisfactionSurveyView>(path(enrollmentId), {
    score,
    confirmEnrollmentId: enrollmentId,
  });
